import { render, staticRenderFns } from "./successFrom.vue?vue&type=template&id=22d524ae&scoped=true&"
import script from "./successFrom.vue?vue&type=script&lang=js&"
export * from "./successFrom.vue?vue&type=script&lang=js&"
import style0 from "./successFrom.vue?vue&type=style&index=0&id=22d524ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d524ae",
  null
  
)

export default component.exports